module.exports = __webpack_public_path__ + "static/img/my1.df0ec24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my1.png
// module id = P/Wj
// module chunks = 1